import { useQuery } from 'react-query'

import { scanService } from 'src/services/scan.service'

import { QUERY_KEYS } from 'src/constants'

export const useScanDraftsCount = () => {
  return useQuery([QUERY_KEYS.SCAN_DRAFTS_COUNT], () => scanService.getDraftScansCount(), {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  })
}
